
export function getForeignLegalRepresentativeData(foreignLegalRepresentativeDataRepository) {
  return foreignLegalRepresentativeDataRepository.get();
}
